import { IPromise } from 'angular';
import { IResult } from '../ServerApi/types/IResponse';
import * as _ from 'underscore';

import { ResultHelper } from '../helpers/ResultHelper';
import { Messages } from '../../codegen/Localize';
import { Module } from '../Module';
import { DeleteOrphanedManagedKeychainRequest } from '../ServerApi/requests/DeleteOrphanedManagedKeychainRequest';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { ServerService } from './ServerService';
import { ToasterService, ToastType } from './ToasterService';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';

export class ClearOrphanedManagedKeychainAction {

  public static $inject = [
    'ServerService'
  ];

  constructor(
    private serverService: ServerService
  ) { }

  public confirmDeleteOrphanedManagedKeychain(): IPromise<any> {
    const confirmationDialogInstance = openReactConfirmationDialog<void, IResult>({
      title: Messages.clearOrphanedManagedKeychain(),
      message: Messages.clearOrphanedManagedKeychainConfirmMessage(),
      actionName: Messages.clearOrphanedManagedKeychainConfirmButton(),
      paramsForAction: null,
      isActionDelete: true,
      action: () => {
        return this.serverService.sendRequest(new DeleteOrphanedManagedKeychainRequest({}));
      },
      dialogWidth: TabDialogWidth.width375px
    });

    confirmationDialogInstance.result.then((result: any) => {
      if (ResultHelper.hasErrors(result)){
        ToasterService.instance.pop({ type: ToastType.Info, text: Messages.clearOrphanedManagedKeychainError() });
      }
      else{
        ToasterService.instance.pop({ type: ToastType.Info, text: Messages.clearOrphanedManagedKeychainSuccess() });
      }
      confirmationDialogInstance.close();
    });

    return confirmationDialogInstance.result;
  }

}

Module.instance().service('ClearOrphanedManagedKeychainAction', ClearOrphanedManagedKeychainAction);